import { useRecoilValue } from 'recoil';

import { isDocumentAuthenticated } from '../atoms/isDocumentAuthenticated';

export default function useIsDocumentAuthenticated() {
  return useRecoilValue(isDocumentAuthenticated);
}
